import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CognitoService } from "src/app/core/services/cognito/cognito.service";
import { NotificationService } from "src/app/core/services/notification/notification.service";
import { RestCallService } from "src/app/core/services/rest-call/rest-call.service";
import { TranslateApplicationService } from "src/app/core/translate/translate-application-service";
import { ISubtypesVisits } from '../Interfaces/ISubtypesVisits';

@Injectable({
  providedIn: 'root',
})
export class SubtypesVisitsService extends RestCallService {

  public dataSubtypeVisitToSend: ISubtypesVisits = {
    pk_subtype_visit: 0,
    subtype_visit: '',
    creation_date: new Date(),
    fk_employee_creator: 0,
    last_updated: new Date(),
    fk_employee_updater: 0,
    available: false,
    username: '',
    fksite: 0
  }
   constructor(
		public httpClient: HttpClient,
		private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient,'JACSapi',toastr,notificationService,translate);
   }
  
  public GetSubtypesVisits() {
     if (!this.cognitoService.IsAuhtenticated()) {
      this.cognitoService.LogOut();
     }
    
    this.dataSubtypeVisitToSend.fksite = Number(window.localStorage.getItem('pksite'));
    
    return this.post<ISubtypesVisits[]>(
      '/api/SubtypesVisits/GetSubtypesVisits',
      this.dataSubtypeVisitToSend
    );
  }
}